// extracted by mini-css-extract-plugin
module.exports = {"loader":"style_loader__1_lp7","spin":"style_spin__3D1kU"};